import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { PlusIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  TabbedPageLayout,
  type RoutedTab,
} from '@/components/tabbed-page-layout';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute(
  '/_auth/_side-layout/actions/your-actions',
)({
  // Your Actions: the org's saved catalog-action instances (Actions tab) and the
  // feed of every action run (Activity tab).
  component: () => (
    <TabbedPageLayout
      title="Your Actions"
      description="The actions you've added. Run them once or on a schedule."
      isNew
      tabs={TABS}
      actions={
        <Button asChild iconLeft={<PlusIcon />}>
          <Link to="/actions/catalog">Add Action</Link>
        </Button>
      }
    />
  ),
  beforeLoad: async ({ context }) => {
    if (!hasPermission(context.userRole, { organization: ['update'] })) {
      throw redirect({ to: '/' });
    }
  },
});

const TABS: RoutedTab[] = [
  { to: '/actions/your-actions/actions', label: 'Library' },
  { to: '/actions/your-actions/activity', label: 'Activity Log' },
];
